import { DayIcon } from "../components/icons/DayIcon";
import { SwingIcon } from "../components/icons/SwingIcon";
import { GraveIcon } from "../components/icons/GraveIcon";

const getShiftIcon = (type) => {
  if (type === "Day") return <DayIcon />;
  if (type === "Swing") return <SwingIcon />;
  if (type === "Grave") return <GraveIcon />;

  return null;
};

export { getShiftIcon };